export default __webpack_public_path__ + "static/char-v-47-8f7c67b9c4d945d961605e93ec52e0e3.webp";